import { ViewVerticalIcon } from '@radix-ui/react-icons'
import type { DataTableInstance, DataTableRowData } from 'blocks/cx-data-table/types'
import { Button, type ButtonProps } from 'primitives/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from 'primitives/dropdown-menu'
import { Tooltip } from 'primitives/tooltip'
import { ShowHideColumnsMenu } from '../menu/column-visibility-menu'

export interface ColumnVisibilityToggleButtonProps<TData extends DataTableRowData>
  extends ButtonProps {
  table: DataTableInstance<TData>
}

export const ColumnVisibilityToggleButton = <TData extends DataTableRowData>(
  props: ColumnVisibilityToggleButtonProps<TData>,
) => {
  const { title, table, ...rest } = props
  const {
    localization: { showHideColumns },
  } = table.options
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div>
          <Tooltip content={title ?? showHideColumns}>
            <Button variant="dashed" {...rest}>
              <ViewVerticalIcon />
              Columns
            </Button>
          </Tooltip>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-64">
        <ShowHideColumnsMenu table={table} />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
